module.exports = __webpack_public_path__ + "static/img/karty.490d71de.png";